// src/pages/Ganaay.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const GanaayHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Study Material");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/ganaay");
  };

  // Tab categories (top horizontal scrollable on mobile)
  const tabGroups = [
    { label: "Study Material", emoji: "📚" },
    { label: "Offline Centers", emoji: "🏫" },
    { label: "Live", emoji: "💻" },
    { label: "Assessment", emoji: "📝" },
    { label: "Engage", emoji: "🤝" },
    { label: "Tools", emoji: "🧰" },
    { label: "Support", emoji: "🔧" },
  ];

  // All feature buttons with group and route
  const menuButtons = [
    // Study Material
    { label: "Immersive BookWorld", emoji: "📖", link: "/bookworld", group: "Study Material" },
    { label: "Ganaay BookSelf", emoji: "📖", link: "/bookshelf", group: "Study Material" },
    { label: "Read / Listen Books", emoji: "📚", link: "/flipbook-home", group: "Study Material" },
    { label: "Note-to-Audio", emoji: "🎙️", link: "/podcast-mylist", group: "Study Material" },
    { label: "Digital Writing Paper", emoji: "✍️📄", link: "/sheearns-touchbookplain", group: "Study Material" },
    { label: "Digital Writing Grid", emoji: "✍️📊", link: "/sheearns-touchbookgrid", group: "Study Material" },
    { label: "Digital Voice Writing", emoji: "🎙️✍️", link: "/sheearns-voicebook", group: "Study Material" },    
    { label: "Handwritten Sync", emoji: "✍️", link: "/handnote-sync", group: "Study Material" },
    { label: "Buy Digital Material", emoji: "🛒", link: "/orderflow-home", group: "Study Material" },
    { label: "Printed Books Dispatch", emoji: "📦", link: "/ganaay-print-orders", group: "Study Material" },

    // Offline Centers
    { label: "Center Dashboard", emoji: "🏢", link: "/ganaay-centers", group: "Offline Centers" },
    { label: "Batch Management", emoji: "👥", link: "/ganaay-batches", group: "Offline Centers" },
    { label: "Attendance (QR)", emoji: "📱", link: "/chronocheck-home", group: "Offline Centers" },
    { label: "Admissions", emoji: "📋", link: "/ganaay-admissions", group: "Offline Centers" },

    // Live
    { label: "Live Classes", emoji: "▶️", link: "/edutube/ganaay", group: "Live" },
    { label: "Online Batches", emoji: "💻", link: "/ganaay-online-batches", group: "Live" },
    { label: "Faculty Portal", emoji: "🎓", link: "/ganaay-faculty", group: "Live" },
    { label: "Start Live Class", emoji: "📡", link: "/edutube/गरीब का", group: "Live" },

    // Assessment
    { label: "Chapter Tests", emoji: "📝", link: "/testbook-home", group: "Assessment" },
    { label: "All India Tests", emoji: "🏆", link: "/testbook-home", group: "Assessment" },
    { label: "AI Question Generator", emoji: "🤖", link: "/ai-questions", group: "Assessment" },
    { label: "Result Analytics", emoji: "📊", link: "/ganaay-analytics", group: "Assessment" },

    // Engage
    { label: "Student Forum", emoji: "💬", link: "/povify-home", group: "Engage" },
    { label: "Leaderboards", emoji: "🏅", link: "/ganaay-leaderboard", group: "Engage" },
    { label: "Podcasts", emoji: "🎧", link: "/podcast-mylist", group: "Engage" },
    { label: "Events & Webinars", emoji: "📅", link: "/event-flow-home", group: "Engage" },

    // Tools
    { label: "Bloom Room", emoji: "🌱", link: "/bloom-room", group: "Tools" },
    { label: "Rubric Builder", emoji: "📏", link: "/rubric-grading-hub", group: "Tools" },
    { label: "Digital Cards", emoji: "📇", link: "/msme-digitalcard", group: "Tools" },
    { label: "Teacher Dashboard", emoji: "👨‍🏫", link: "/ganaay-teacher", group: "Tools" },

    // Support
    { label: "AI Counselling", emoji: "🧠", link: "/ai-counselling", group: "Support" },
    { label: "Chat Support", emoji: "💬", link: "/ganaay-chat", group: "Support" },
    { label: "Payments & EMI", emoji: "💳", link: "/ganaay-payments", group: "Support" },
    { label: "Franchise Kit", emoji: "📋", link: "/ganaay-franchise", group: "Support" },
  ];

  const filteredButtons = menuButtons.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-[#050607 text-slate-100 font-sans">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#2a0f2f] border-b border-emerald-800 px-4 py-3 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
          <div className="text-xl lg:text-2xl font-bold text-white">Ganaay</div>
          <div className="text-sm lg:text-m text-yellow-200">JEE • NEET Orbit</div>
        </div>

        {/* Desktop Auth */}
        <div className="hidden md:flex items-center gap-4">
          {isLoggedIn ? (
            <>
              <span className="text-xs text-emerald-300">{userName}</span>
              <button
                onClick={handleLogout}
                className="mt-4 w-10 p-2 rounded-lg bg-rose-600 hover:bg-rose-700 transition text-white"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-4 py-2 rounded-full border border-emerald-700 text-sm hover:bg-emerald-900/50 transition"
              >
                Login
              </button>
            </>
          )}
        </div>

        {/* Mobile Menu Toggle */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden text-xl w-10 text-emerald-400"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#1e0b24] border-b border-emerald-900 px-4 py-4">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-4">
              <div className="text-emerald-300 text-xs font-medium">{userName}</div>
              <button
                onClick={handleLogout}
                className="px-6 py-2 bg-rose-600 rounded-lg hover:bg-rose-700"
              >
                Logout
              </button>
            </div>
          ) : (
            <div className="flex justify-center gap-8 text-emerald-300 text-lg">
              <button onClick={() => navigate("/login")}>Login</button>
              {/* <button onClick={() => navigate("/signup")}>Register</button> */}
            </div>
          )}
        </div>
      )}

      {/* Top Quick Links */}
       <div className="bg-[#3b0b44] text-white text-xs sm:text-sm py-2 mb-2">
        <div className="mx-auto px-3 flex flex-row justify-center gap-2">
          <button onClick={() => navigate("/ganaay-about")} className="text-xs lg:text-sm hover:text-yellow-200">💭 About Ganaay</button>
          <button onClick={() => navigate("/ganaay-faq")} className="text-xs lg:text-sm hover:text-yellow-200">🤔 FAQ</button>
          <button onClick={() => navigate("/ganaay-updates")} className="text-xs lg:text-sm hover:text-yellow-200">📊 Ganaay Updates</button>
          <button onClick={() => navigate("/jeeneet-updates")} className="text-xs lg:text-sm hover:text-yellow-200">🗞️ JEE-NEET Bulletin</button>
          <button onClick={() => navigate("/ganaay-contact")} className="text-xs lg:text-sm hover:text-yellow-200">🤖 Support</button>
        </div>
      </div>

      {/* Tabs */}
      <div className="bg-[#2a0f2f] border-b border-emerald-800 px-2 py-3 overflow-x-auto">
        <div className="flex gap-2 min-w-max justify-center">
          {tabGroups.map((tab) => (
            <button
              key={tab.label}
              onClick={() => setActiveTab(tab.label)}
              className={`flex flex-col items-center min-w-[80px] px-4 py-3 rounded-lg text-xs font-medium transition ${
                activeTab === tab.label
                  ? "bg-emerald-600/30 border border-emerald-500 text-emerald-300 shadow-lg"
                  : "bg-slate-900/40 text-slate-300 hover:bg-slate-800/60"
              }`}
            >
              <span className="text-2xl mb-1">{tab.emoji}</span>
              <span className="text-center text-[10px] leading-tight">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main Grid */}
      <main className="flex-grow px-4 py-2 pb-4 bg-[#2a0f2f] ">
        <div className="grid grid-cols-5 lg:grid-cols-6 gap-2 max-w-7xl mx-auto bg-[#2a0f2f] ">
          {filteredButtons.length === 0 ? (
            <div className="col-span-full text-center text-slate-500 py-10">
              No features available yet.
            </div>
          ) : (
            filteredButtons.map((btn) => (
              <button
                key={btn.label}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center p-4 rounded-2xl bg-slate-900/40 hover:bg-emerald-900/40 border border-slate-800 hover:border-emerald-700 transition-all duration-200 shadow-md hover:shadow-emerald-700/20"
              >
                <span className="text-3xl mb-2">{btn.emoji}</span>
                <span className="text-xs text-center leading-tight px-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#2a0f2f] border-t border-emerald-800 text-slate-400 py-5 mt-auto">
        <div className="flex px-4 text-center lg:text-left lg:justify-between text-xs space-y-2 lg:flex-row">
          <div className="text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex justify-center gap-6 text-emerald-300">
            <Link to="/about-us" className="text-white hover:text-yellow-200">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-yellow-200">Privacy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-yellow-200">Terms</Link>
            <Link to="/contact-us" className="text-white hover:text-yellow-200">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default GanaayHome;